import { render, staticRenderFns } from "./dialogShell.vue?vue&type=template&id=1c7eac40&scoped=true&"
import script from "./dialogShell.vue?vue&type=script&lang=js&"
export * from "./dialogShell.vue?vue&type=script&lang=js&"
import style0 from "./dialogShell.vue?vue&type=style&index=0&id=1c7eac40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7eac40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VSlideYTransition})
